import {useAppSelector} from "hooks/useAppSelector";
import { useWindowSize } from "app/utils/hooks/useWindowSize";

export const useCurrencyToolbarData = () => {
    const isAuth = useAppSelector((state) => state.user.isLogin);
    const { isMobile, isTablet } = useWindowSize();

    return {
        isAuth,
        isMobile,
        isTablet
    }
}